import React from 'react';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';
import { TopRowBox } from '../../../../../tradeplans/activeTradePlanModule/components/topRows/topRowBox/TopRowBox';
import { colors } from '../../../../../../../colorVars';

const BidAskBox = observer(({ symbol, dataSource }) => {
  const { priceDataStore } = useWebsocketStore();

  const hash = `${symbol}-${dataSource}`;
  const { bid, ask } = priceDataStore.lastQuote[hash] ?? { bid: 0, ask: 0 };
  return (
    <>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={colors.lightGrey}>{`Bid: ${bid !== undefined ? bid.toFixed(2) : ''}`}</TopRowBox>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={colors.lightGrey}>{`Ask: ${ask !== undefined ? ask.toFixed(2) : ''}`}</TopRowBox>
    </>
    // <div className={style.dataBoxContainer}>
    //   <div className={style.dataBox}>
    //     <p>
    //       <span className={style.dataLabel}>B: </span>
    //       <span className={style.data}>
    //         {bid !== undefined ? bid.toFixed(2) : ''}
    //       </span>
    //     </p>
    //   </div>
    //   <div className={style.dataBox}>
    //     <p>
    //       <span className={style.dataLabel}>A: </span>
    //       <span className={style.data}>
    //         {ask !== undefined ? ask.toFixed(2) : ''}
    //       </span>
    //     </p>
    //   </div>
    // </div>
  );
});

export default BidAskBox;
